import request from '@/utils/request'
// 嘉宾接口

export function submitInfo (data) {
    return request({
        url: 'notcheck/register/paymentGuest',
        method: 'post',
        data
    })
}
